<template>
  <div
    class="dragImg"
    :class="{ 'dragImg--fixed': fixedPosition }"
    :style="rootStyle"
    :data-fixed-sign="fixedPosition ? '1' : '0'"
  >
    <!-- 固定位置模式：直接落在配置坐标，不可拖动 -->
    <div v-if="fixedPosition" class="dragImg-fixed-inner">
      <img
        :class="'imgType_' + imgType"
        class="dragImg-fixed-img"
        :src="imgSrc"
      />
    </div>

    <!-- 自由拖动模式（无配置坐标时使用） -->
    <template v-else>
      <div
        ref="canMove"
        style="position: relative; width: 100%; height: 100%; overflow: hidden"
      >
        <div
          id="pic"
          ref="dragDiv"
          :style="{ height: imgSize('h'), width: imgSize('w'), top: addPx(top) }"
          class="backIcon"
          style="
            left: 47%;
            transform: translate(-1px, -1px);
            position: absolute;
            z-index: 233;
          "
        >
          <div
            v-drag="{ that }"
            onclick=""
            style="width: 100%; height: 100%; position: absolute"
          >
            <div v-show="showOption" class="imgBtn" style="right: 100%">
              <a class="pointer" @click="destroySelf()"
                ><i class="el-icon-delete"></i
              ></a>
              <a @click="imgEnlarge()"><i class="el-icon-zoom-in"></i></a>
              <a @click="imgNarrow()"><i class="el-icon-zoom-out"></i></a>
            </div>
            <img
              :class="'imgType_' + imgType"
              style="width: 100%"
              :src="imgSrc"
            />
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "DragImg",
  props: {
    imgData: {
      type: String,
      default: "",
    },
    imgType: {
      type: String,
      default: "seal",
    },
    top: {
      type: Number,
      default: 0,
    },
    isReuse: {
      type: Boolean,
      default: false,
    },
    currentPageNum: {
      type: String,
      default: "1",
    },
    deleteDragImg: {
      type: Function,
      value: null,
    },
    pauseHandle: {
      type: Function,
      value: null,
    },
    fixedPosition: {
      type: Boolean,
      default: false,
    },
    initialLeftPx: {
      type: Number,
      default: 0,
    },
    initialTopPx: {
      type: Number,
      default: 0,
    },
    initialWidthPx: {
      type: Number,
      default: 0,
    },
    initialHeightPx: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      that: this,
      showOption: true,
      imgSrc: "",
      imgWidth: 80,
      imgHeight: 30,
      position: { x: 0, y: 0 },
      cx: "",
      cy: "",
      x: "",
      y: "",
      l: "",
      t: "",
      r: "",
      b: "",
      curx: 0,
      cury: 0,
      w: 0,
      h: 0,
    };
  },
  computed: {
    rootStyle() {
      if (this.fixedPosition) {
        return {
          position: "absolute",
          left: `${this.initialLeftPx}px`,
          top: `${this.initialTopPx}px`,
          width: `${this.initialWidthPx}px`,
          height: `${this.initialHeightPx}px`,
          zIndex: 233,
          pointerEvents: "none",
        };
      }
      return {
        width: "100%",
        height: "100%",
        position: "absolute",
        top: "0px",
        left: "0px",
      };
    },
  },
  created() {
    this.overThis = this;
  },
  directives: {
    drag: {
      bind: function (el, binding) {
        let oDiv = el;
        let that = binding.value.that;
        if (that.fixedPosition) return;
        oDiv.onmousedown = function (e) {
          e.preventDefault();
          const isPause = that.pauseHandle() || false;
          if (isPause) return;
          let bw = document.body.clientWidth;
          let bh = document.body.clientHeight;
          let disX = e.clientX - oDiv.offsetLeft;
          let disY = e.clientY - oDiv.offsetTop;
          document.onmousemove = function (e) {
            let l = 0,
              t = 0;
            if (e.clientX >= bw) {
              l = bw - disX;
            } else if (e.clientX <= 0) {
              l = 0 - disX;
            } else {
              l = e.clientX - disX;
            }
            if (e.clientY >= bh) {
              t = bh - disY;
            } else if (e.clientY <= 0) {
              t = 0 - disY;
            } else {
              t = e.clientY - disY;
            }
            oDiv.style.left = l + "px";
            oDiv.style.top = t + "px";
          };
          document.onmouseup = function () {
            document.onmousemove = null;
            document.onmouseup = null;
          };
        };
      },
    },
  },
  methods: {
    parseMatrix(matrixString) {
      const matches = matrixString.match(/-?\d*\.?\d+/g);
      if (!matches) {
        throw new Error("Invalid matrix string format.");
      }
      return matches.map(Number);
    },
    addPx(value) {
      return (value += "px");
    },
    imgSize(type) {
      if (type == "w") {
        return this.imgWidth + "px";
      }
      return this.imgHeight + "px";
    },
    imgEnlarge() {
      if (this.imgType == "sign") {
        this.imgWidth += 10;
        this.imgHeight += 3;
      } else {
        this.imgWidth += 10;
        this.imgHeight += 10;
      }
    },
    imgNarrow() {
      if (this.imgType == "sign") {
        this.imgWidth -= 10;
        this.imgHeight -= 3;
      } else {
        this.imgWidth -= 10;
        this.imgHeight -= 10;
      }
    },
    destroySelf() {
      this.deleteDragImg(this.isReuse);
      this.$destroy();
      this.$el.parentNode.removeChild(this.$el);
    },
    phoneDown(event) {
      if (this.fixedPosition) return;
      let moveDiv = this.$refs["dragDiv"];
      this.position.x = moveDiv.offsetLeft;
      this.l = moveDiv.offsetLeft;
      this.position.y = moveDiv.offsetTop;
      this.t = moveDiv.offsetTop;
      let touch = event.touches ? event.touches[0] : event;
      this.cx = touch.clientX;
      this.cy = touch.clientY;
    },
    phoneMove(event) {
      if (this.fixedPosition) return;
      let moveDiv = this.$refs["dragDiv"];
      let touch = event.touches ? event.touches[0] : event;
      event.preventDefault();
      this.curx = touch.clientX - this.cx;
      this.cury = touch.clientY - this.cy;
      if (this.curx > 0) {
        this.curx = Math.abs(this.curx) > this.r ? this.r : this.curx;
      } else {
        this.curx = Math.abs(this.curx) > this.l ? -this.l : this.curx;
      }
      if (this.cury > 0) {
        this.cury = Math.abs(this.cury) > this.b ? this.b : this.cury;
      } else {
        this.cury = Math.abs(this.cury) > this.t ? -this.t : this.cury;
      }
      moveDiv.style.transform = `translate(${this.curx}px,${this.cury}px)`;
    },
    phoneEnd() {
      if (this.fixedPosition) return;
      let moveDiv = this.$refs["dragDiv"];
      let aa = 0;
      let bb = 0;
      const style = window.getComputedStyle(moveDiv);
      const transformValue = style.getPropertyValue("transform");
      if (transformValue !== "none") {
        const matches = this.parseMatrix(transformValue);
        if (matches) {
          aa = parseInt(matches[4]);
          bb = parseInt(matches[5]);
        }
      }
      let ax = parseInt(this.position.x) + aa;
      let by = parseInt(this.position.y) + bb;
      moveDiv.style.left = ax + "px";
      moveDiv.style.top = by + "px";
      moveDiv.style.transform = "";
      this.l = ax;
      this.t = by;
      this.r = this.w - this.l - this.x;
      this.b = this.h - this.t - this.y;
    },
    bindTouchEvents() {
      if (this.fixedPosition) return;
      const moveDiv = this.$refs["dragDiv"];
      if (!moveDiv) return;
      moveDiv.addEventListener("touchstart", this.phoneDown, { passive: false });
      moveDiv.addEventListener("touchmove", this.phoneMove, { passive: false });
      moveDiv.addEventListener("touchend", this.phoneEnd, { passive: false });
    },
  },
  mounted() {
    this.imgWidth = this.imgType == "sign" ? 80 : 80;
    this.imgHeight = this.imgType == "sign" ? 30 : 80;
    if (this.fixedPosition) {
      if (this.initialWidthPx > 0) {
        this.imgWidth = Math.round(this.initialWidthPx);
      }
      if (this.initialHeightPx > 0) {
        this.imgHeight = Math.round(this.initialHeightPx);
      }
    }
    if (this.imgData) {
      this.imgSrc = this.imgData;
    }
    if (!this.fixedPosition) {
      const canMove = this.$refs["canMove"];
      if (canMove) canMove.style.height = "100%";
      const moveDiv = this.$refs["dragDiv"];
      this.w = document.documentElement.clientWidth || document.body.clientWidth;
      this.h =
        document.documentElement.clientHeight || document.body.clientHeight;
      this.x = moveDiv.offsetWidth;
      this.y = moveDiv.offsetHeight;
      this.bindTouchEvents();
      this.l = moveDiv.offsetLeft;
      this.t = moveDiv.offsetTop;
      this.r = this.w - this.l - this.x;
      this.b = this.h - this.t - this.y;
    }
  },
};
</script>

<style>
.dragImg--fixed {
  box-sizing: border-box;
  overflow: hidden;
}

.dragImg-fixed-inner {
  width: 100%;
  height: 100%;
}

.dragImg-fixed-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.imgBtn {
  position: absolute;
  background: #409eff;
}

.imgBtn a {
  color: #fff !important;
  padding: 2px 4px;
  margin: 10px 0px;
  text-align: center;
  display: block;
}
#pic img {
  height: 100% !important;
}

.backIcon div {
  position: absolute;
}
</style>
